import React from 'react'

import InviteDoctorForm from './InviteDoctorForm'

function PharmaAdministration() {
  return <InviteDoctorForm />
}

export default PharmaAdministration
